import { BillingExports } from '@client/api-internal/BillingExports';
import { fetchFinanceBrandContact } from '@monolith/legacy/modules/shared/services/brand-contacts.service';
import { deserialize } from '@monolith/legacy/services/utils/jsonapi-parser';

export enum ActionName {
  FETCH_EXPORT_LIST = 'fetchExportList',
  FETCH_FINANCE_CONTACT = 'fetchFinanceContact',
}

const billingExports = new BillingExports();

export const actions = {
  [ActionName.FETCH_EXPORT_LIST]: async ({ commit }) => {
    const response = await billingExports.orderingBillingExportsListPublic();
    const deserialized = deserialize(response);
    commit('SET_EXPORT_LIST', deserialized.data);
  },
  [ActionName.FETCH_FINANCE_CONTACT]: async ({ commit, rootGetters }) => {
    const brandUuid = rootGetters['brand']?.uuid;
    if (!brandUuid) {
      commit('SET_HAS_FINANCE_CONTACT', false);
      return;
    }
    const contact = await fetchFinanceBrandContact(brandUuid);
    commit('SET_HAS_FINANCE_CONTACT', contact !== null);
  },
};
